var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _ from 'lodash';
import { types, flow } from 'mobx-state-tree';
import RestApiServiceFactory from '../api/rest/RestApiServiceFactory';
import PermissionCache from '../models/PermissionCache';
import Role from '../models/Role';
import AuthorizationConfigType from '../types/AuthorizationConfigType';
import RoleStore from './RoleStore';
var AuthorizationStore = types
    .model({
    config: AuthorizationConfigType,
    roleStore: types.optional(RoleStore, function () { return RoleStore.create(); }),
    permissionCaches: types.array(PermissionCache),
    activePermissionCache: types.maybe(types.safeReference(PermissionCache)),
    debugRole: Role,
    activeTenantId: types.maybe(types.string),
    activeSubjectId: types.maybe(types.string)
})
    .named('AuthorizationStore')
    .views(function (_self) { return ({}); })
    .actions(function (self) { return ({
    setActiveTenantId: function (activeTenantId) {
        self.activeTenantId = activeTenantId;
    },
    setActiveSubjectId: function (activeSubjectId) {
        self.activeSubjectId = activeSubjectId;
    },
    setActivePermissionCache: flow(function setActivePermissionCache(subjectId, tenantId) {
        var permissionCache, permissionCacheSnapshot, model;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    permissionCache = self.permissionCaches.find(function (x) { return x.subjectId === subjectId && x.tenantId === tenantId; });
                    if (!!permissionCache) return [3 /*break*/, 2];
                    self.activePermissionCache = undefined;
                    return [4 /*yield*/, RestApiServiceFactory.permissionCacheApiService.getPermissionCacheAsync()];
                case 1:
                    permissionCacheSnapshot = _a.sent();
                    model = PermissionCache.create(permissionCacheSnapshot);
                    self.permissionCaches.push(model);
                    self.activePermissionCache = model;
                    return [2 /*return*/];
                case 2:
                    self.activePermissionCache = permissionCache;
                    return [2 /*return*/];
            }
        });
    }),
    setDefaultPermissionCacheAsActive: function () {
        var defaultPermissionCache = PermissionCache.create({
            subjectId: 'default',
            tenantId: 'default',
            resourceSubjectPermissionCollections: _.values(self.config.permissionLevels).map(function (permissionLevel) { return ({
                pathIndex: permissionLevel.pathIndex,
                levelIndex: permissionLevel.levelIndex
            }); })
        });
        self.permissionCaches.push(defaultPermissionCache);
        self.activePermissionCache = defaultPermissionCache;
    }
}); });
export default AuthorizationStore;
//# sourceMappingURL=AuthorizationStore.js.map